// import React, { useState, useEffect } from 'react';
// import {
//   BrowserRouter as Router,
//   Route,
//   Routes,
//   Navigate,
// } from 'react-router-dom';
// import SignUp from './components/SignUp';
// import SignIn from './components/SignIn';
// import FileUpload from './components/FileUpload';
// import ResultsTable from './components/ResultsTable';
// import SavedCandidates from './components/SavedCandidates';
// import InterviewTracking from './components/InterviewTracking';
// import CandidateProfile from './components/CandidateProfile';
// import NavigationHeader from './components/NavigationHeader';
// import ForgotPassword from './components/ForgotPassword';
// import ResetPassword from './components/ResetPassword';
// import QualifiedCandidates from './components/QualifiedCandidates';

// function App() {
//   // Initialize isLoggedIn state from localStorage
//   const [isLoggedIn, setIsLoggedIn] = useState(() => {
//     // Check if user is logged in from localStorage
//     return localStorage.getItem('isLoggedIn') === 'true';
//   });
//   const [analysisResults, setAnalysisResults] = useState([]);

//   // Update localStorage when isLoggedIn changes
//   useEffect(() => {
//     if (isLoggedIn) {
//       localStorage.setItem('isLoggedIn', 'true');
//     } else {
//       localStorage.removeItem('isLoggedIn');
//     }
//   }, [isLoggedIn]);

//   // Create a wrapper for setIsLoggedIn to handle both state and localStorage
//   const handleLogout = () => {
//     setIsLoggedIn(false);
//     // localStorage.removeItem is handled in the useEffect
//   };

//   return (
//     <Router>
//       <Routes>
//         {/* Public routes */}
//         <Route path='/signup' element={<SignUp />} />
//         <Route
//           path='/signin'
//           element={<SignIn setIsLoggedIn={setIsLoggedIn} />}
//         />
//         <Route path='/forgotpassword' element={<ForgotPassword />} />
//         <Route path='/resetpassword' element={<ResetPassword />} />

//         {/* Protected routes */}
//         <Route
//           path='/candidates'
//           element={
//             isLoggedIn ? (
//               <>
//                 <NavigationHeader setIsLoggedIn={handleLogout} />
//                 <SavedCandidates />
//               </>
//             ) : (
//               <Navigate to='/signin' replace />
//             )
//           }
//         />
//         <Route
//           path='/candidates/:id'
//           element={
//             isLoggedIn ? (
//               <>
//                 <NavigationHeader setIsLoggedIn={handleLogout} />
//                 <CandidateProfile />
//               </>
//             ) : (
//               <Navigate to='/signin' replace />
//             )
//           }
//         />
//         <Route
//           path='/qualified-candidates'
//           element={
//             isLoggedIn ? (
//               <>
//                 <NavigationHeader setIsLoggedIn={handleLogout} />
//                 <QualifiedCandidates />
//               </>
//             ) : (
//               <Navigate to='/signin' replace />
//             )
//           }
//         />
//         <Route
//           path='/interview-tracking'
//           element={
//             isLoggedIn ? (
//               <>
//                 <NavigationHeader setIsLoggedIn={handleLogout} />
//                 <InterviewTracking />
//               </>
//             ) : (
//               <Navigate to='/signin' replace />
//             )
//           }
//         />
//         <Route
//           path='/upload'
//           element={
//             isLoggedIn ? (
//               <>
//                 <NavigationHeader setIsLoggedIn={handleLogout} />
//                 <FileUpload setAnalysisResults={setAnalysisResults} />
//               </>
//             ) : (
//               <Navigate to='/signin' replace />
//             )
//           }
//         />
//         <Route
//           path='/results'
//           element={
//             isLoggedIn ? (
//               <>
//                 <NavigationHeader setIsLoggedIn={handleLogout} />
//                 <ResultsTable analysisResults={analysisResults} />
//               </>
//             ) : (
//               <Navigate to='/signin' replace />
//             )
//           }
//         />

//         {/* Default route */}
//         <Route
//           path='/'
//           element={
//             isLoggedIn ? (
//               <Navigate to='/candidates' replace />
//             ) : (
//               <Navigate to='/signin' replace />
//             )
//           }
//         />
//       </Routes>
//     </Router>
//   );
// }

// export default App;

import React, { useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from 'react-router-dom';
import SignUp from './components/SignUp';
import SignIn from './components/SignIn';
import FileUpload from './components/FileUpload';
import ResultsTable from './components/ResultsTable';
import SavedCandidates from './components/SavedCandidates';
import InterviewTracking from './components/InterviewTracking';
import CandidateProfile from './components/CandidateProfile';
import NavigationHeader from './components/NavigationHeader';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import QualifiedCandidates from './components/QualifiedCandidates';
import CandidateDashboard from './components/CandidateDashboard';
import AdminPanel from './components/AdminPanel';
import { AnalysisProvider } from './context/AnalysisContext';
import GlobalAnalysisWidget from './components/GlobalAnalysisWidget';

function App() {
  // Initialize isLoggedIn state from localStorage
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    return localStorage.getItem('isLoggedIn') === 'true';
  });
  const [analysisResults, setAnalysisResults] = useState([]);
  const [userRole, setUserRole] = useState(() => {
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      return user?.role || 'hr';
    } catch {
      return 'hr';
    }
  });

  // Update localStorage when isLoggedIn changes
  useEffect(() => {
    if (isLoggedIn) {
      localStorage.setItem('isLoggedIn', 'true');
      // Refresh role from localStorage when login state changes
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        setUserRole(user?.role || 'hr');
      } catch {
        setUserRole('hr');
      }
    } else {
      localStorage.removeItem('isLoggedIn');
    }
  }, [isLoggedIn]);

  // Create a wrapper for setIsLoggedIn to handle both state and localStorage
  const handleLogout = () => {
    setIsLoggedIn(false);
    setUserRole('hr');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('isLoggedIn');
  };

  return (
    <AnalysisProvider>
      <Router>
        <GlobalAnalysisWidget />
        <Routes>
          {/* Public routes */}
          <Route path='/signup' element={<SignUp />} />
          <Route
            path='/signin'
            element={<SignIn setIsLoggedIn={setIsLoggedIn} />}
          />
          <Route path='/forgotpassword' element={<ForgotPassword />} />
          <Route path='/resetpassword' element={<ResetPassword />} />

          {/* Protected routes */}

          {/* Dashboard */}
          <Route
            path='/dashboard'
            element={
              isLoggedIn ? (
                <>
                  <NavigationHeader setIsLoggedIn={handleLogout} userRole={userRole} />
                  <CandidateDashboard />
                </>
              ) : (
                <Navigate to='/signin' replace />
              )
            }
          />

          {/* Admin Panel (admin-only) */}
          <Route
            path='/admin'
            element={
              isLoggedIn && userRole === 'admin' ? (
                <>
                  <NavigationHeader setIsLoggedIn={handleLogout} userRole={userRole} />
                  <AdminPanel />
                </>
              ) : isLoggedIn ? (
                <Navigate to='/dashboard' replace />
              ) : (
                <Navigate to='/signin' replace />
              )
            }
          />

          <Route
            path='/candidates'
            element={
              isLoggedIn ? (
                <>
                  <NavigationHeader setIsLoggedIn={handleLogout} userRole={userRole} />
                  <SavedCandidates />
                </>
              ) : (
                <Navigate to='/signin' replace />
              )
            }
          />
          <Route
            path='/candidates/:id'
            element={
              isLoggedIn ? (
                <>
                  <NavigationHeader setIsLoggedIn={handleLogout} userRole={userRole} />
                  <CandidateProfile />
                </>
              ) : (
                <Navigate to='/signin' replace />
              )
            }
          />
          <Route
            path='/qualified-candidates'
            element={
              isLoggedIn ? (
                <>
                  <NavigationHeader setIsLoggedIn={handleLogout} userRole={userRole} />
                  <QualifiedCandidates />
                </>
              ) : (
                <Navigate to='/signin' replace />
              )
            }
          />
          <Route
            path='/interview-tracking'
            element={
              isLoggedIn ? (
                <>
                  <NavigationHeader setIsLoggedIn={handleLogout} userRole={userRole} />
                  <InterviewTracking />
                </>
              ) : (
                <Navigate to='/signin' replace />
              )
            }
          />
          <Route
            path='/upload'
            element={
              isLoggedIn ? (
                <>
                  <NavigationHeader setIsLoggedIn={handleLogout} userRole={userRole} />
                  <FileUpload setAnalysisResults={setAnalysisResults} />
                </>
              ) : (
                <Navigate to='/signin' replace />
              )
            }
          />
          <Route
            path='/results'
            element={
              isLoggedIn ? (
                <>
                  <NavigationHeader setIsLoggedIn={handleLogout} userRole={userRole} />
                  <ResultsTable analysisResults={analysisResults} />
                </>
              ) : (
                <Navigate to='/signin' replace />
              )
            }
          />

          {/* Default route */}
          <Route
            path='/'
            element={
              isLoggedIn ? (
                <Navigate to='/dashboard' replace />
              ) : (
                <Navigate to='/signin' replace />
              )
            }
          />
        </Routes>
      </Router>
    </AnalysisProvider>
  );
}

export default App;

